export default "__VITE_ASSET__aPdCbqyx__"